import SubstanceJson from "../../js/entities/SubstanceJson.js";

export default class SubstanceDialogFormData {
    id;
    alias;
    mfOrEmw;
    color;
    struct;
    existingDisplayNames;
    aliasAutocompleteList;
    #massSpecEnabled;
    #readOnly;

    constructor({
                    id,
                    alias,
                    mfOrEmw,
                    color,
                    structure,
                    structureSvgPath,
                    existingDisplayNames = [],
                    aliasAutocompleteList = [],
                    massSpecEnabled = false,
                    readOnly = false
                }) {
        this.id = id;
        this.alias = alias;
        this.mfOrEmw = mfOrEmw;
        this.color = color;
        this.struct = structure;
        this.structureSvgPath = structureSvgPath;
        this.existingDisplayNames = existingDisplayNames;
        this.aliasAutocompleteList = aliasAutocompleteList;
        this.#massSpecEnabled = massSpecEnabled;
        this.#readOnly = readOnly;
    }

    get massSpecEnabled(){
        return this.#massSpecEnabled;
    }

    getSubstanceJson() {
        let mf, emw;
        if (typeof this.mfOrEmw === 'number')
            emw = this.mfOrEmw;
        else
            mf = this.mfOrEmw;
        return new SubstanceJson({
            id: this.id,
            alias: this.alias,
            mf: mf,
            emw: emw,
            structureId: this.struct,
            color: this.color
        });
    }

    getSubstanceDisplayName() {
        const {alias, mfOrEmw} = this;
        let name = alias;
        if (name && name.length > 0)
            return name;
        name = mfOrEmw;
        if (typeof name === "number")
            name = SubstanceJson.getEmwDisplayName(name);
        return name || "";
    }

    isReadOnly(){
        return this.#readOnly;
    }

    /**
     * @param {SubstanceJson} substance
     * @param {string[]} [existingDisplayNames]
     * @param {string[]} [aliasAutocompleteList]
     * @param {boolean} massSpecEnabled
     * @param {boolean} readOnly
     */
    static build({substance, existingDisplayNames = [], aliasAutocompleteList = [],
                 massSpecEnabled, readOnly = false}){
        let id, alias, mfOrEmw, color, structure, structureSvgPath;
        if (substance) {
            id = substance.getId();
            alias = substance.getAlias();
            mfOrEmw = substance.getMolecularFormula();
            if (!mfOrEmw)
                mfOrEmw = substance.getMonoIsotopicMass();
            color = substance.getSavedColor();
            structure = substance.getStructureId();
            structureSvgPath = substance.getStructureSvgPath();
        }
        const existingDisplayNamesArray = existingDisplayNames.map(r => r.toLowerCase());
        const aliasAutocompleteListArray = aliasAutocompleteList.map(a => {
            return {displayName: a, value: a}
        });
        return new SubstanceDialogFormData({
            id,
            alias,
            mfOrEmw,
            color,
            structure,
            existingDisplayNames: existingDisplayNamesArray,
            aliasAutocompleteList: aliasAutocompleteListArray,
            structureSvgPath,
            massSpecEnabled,
            readOnly
        });
    }
}